import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog } from 'element-react'

const MaintenanceDialog = props => {
    const { cancel, toggle, show, isMaintenanceMode } = props

    return (
        show && (
            <Dialog
                className="request-type-dialog"
                size="large"
                top="10%"
                title=" "
                visible={true}
                onCancel={cancel}
            >
                <Dialog.Body>
                    <div className="row max400">
                        <div className="text-xl font-bold">
                            Change Maintenance Status?
                        </div>
                        <p>
                            Are you sure you want to turn{' '}
                            {isMaintenanceMode ? 'off' : 'on'} Maintenance Mode?
                        </p>

                        <div className="text-right mt-8">
                            <Button onClick={cancel}>No</Button>
                            <Button type="primary" onClick={toggle}>
                                Yes
                            </Button>
                        </div>
                    </div>
                </Dialog.Body>
            </Dialog>
        )
    )
}

MaintenanceDialog.propTypes = {
    cancel: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    isMaintenanceMode: PropTypes.bool.isRequired,
}

export default MaintenanceDialog
